var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"logout",attrs:{"type":"text"},on:{"click":_vm.logout}},[_vm._v("\n    Logout\n    "),_c('i',{staticClass:"el-icon-caret-right"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }